import api from "./api"
import { RegistrarLogErro } from "./clientefiel"

export interface PromocaoFidelidadeModel {
    possuiDelivery: boolean
    id: number | null
    premio: string
    valorPorSelo: string | null
    valorPremio: string | null
    valorPremioPercentual: string | null
    valorPremioPercentualMedia: string | null
    valorConsumoMinimoParaSelo: string | null
    consumoMinimo: string | null
    quantidadeNecessaria: number
    observacao: string | null
    exibirPublicamente: boolean
    naoPermitirFidelidadeRetiradaLocal: boolean
    regulamentoTexto: string | null
    bonificarIndicacaoAmigos: boolean
    bonificarPesquisaSatisfacao: boolean
    ignorarPedioMinimoNoResgate: boolean
    fatorMultiplicadorSelos: number
    diasValidadeCartela: number
    diasRenovacao: number
    maximoRegistroSelosImpressosDiarios: number
    maximoRegistroSelosVirtuaisDiarios: number
    permiteResgateAnonimo: boolean
    validarMaximoDiarioDelivery: boolean
    freteGratisCartelaCompleta: boolean
    acumularSaldoRestante: boolean
    pontuarNoDelivery: boolean
    pontuarPorProduto: boolean
}

export interface SalvarPromocaoPayload {
    premio: string
    tipoPontuacao: number
    valorPorSelo: string | null
    tipoPremio: number
    valorPremio: string | null
    valorPremioPercentual: string | null
    valorPremioPercentualMedia: string | null
    consumoMinimo: string | null
    quantidadeNecessaria: number
    valorConsumoMinimoParaSelo: string | null
    observacao: string
    exibirPublicamente: boolean
    naoPermitirFidelidadeRetiradaLocal: boolean
    regulamentoTexto: string
    bonificarIndicacaoAmigos: boolean
    bonificarPesquisaSatisfacao: boolean
    ignorarPedioMinimoNoResgate: boolean
    diasValidadeCartela: number
    diasRenovacao: number
    fatorMultiplicadorSelos: number
    maximoRegistroSelosImpressosDiarios: number
    maximoRegistroSelosVirtuaisDiarios: number
    permiteResgateAnonimo: boolean
    validarMaximoDiarioDelivery: boolean
    freteGratisCartelaCompleta: boolean
    acumularSaldoRestante: boolean
}

export interface ErroApi {
    retornoErro: number
    mensagem: string
}

type RespostaRaw<T> = T & { codErro?: number; mensagem?: string }

function tratamentoResponse<T>(response: { data: RespostaRaw<T> }, chamada: string): T | ErroApi {
    const { data } = response
    if (data.codErro !== undefined && data.codErro > 0) {
        return { retornoErro: data.codErro, mensagem: data.mensagem ?? "" }
    }
    if (typeof data === "string" && data !== "") {
        return {
            retornoErro: 1,
            mensagem: `${chamada} - Erro inesperado, entre em contato com os responsáveis.`,
        }
    }
    return data
}

function erroParaRespostaRaw(error: unknown): RespostaRaw<never> {
    const axiosError = error as { message?: string; response?: { data?: unknown } }
    const data = axiosError.response?.data
    if (
        typeof data === "object" &&
        data !== null &&
        "codErro" in data &&
        (data as { codErro: number }).codErro > 0
    ) {
        const d = data as { codErro: number; mensagem?: string }
        return { codErro: d.codErro, mensagem: d.mensagem } as RespostaRaw<never>
    }
    if (axiosError.message === "Network Error") {
        return { codErro: 1, mensagem: "Verifique sua conexão!" } as RespostaRaw<never>
    }
    return { codErro: 1, mensagem: axiosError.message || "Erro desconhecido" } as RespostaRaw<never>
}

export const obterDadosPromocaoFidelidade = async function (
    authorization: string
): Promise<PromocaoFidelidadeModel | ErroApi> {
    try {
        const response = await api
            .get<RespostaRaw<PromocaoFidelidadeModel>>("fornecedor/ObterDadosPromocaoFidelidade", {
                headers: { "Content-Type": "application/json", Authorization: authorization },
            })
            .catch(function (error) {
                return { data: erroParaRespostaRaw(error) }
            })

        return tratamentoResponse<PromocaoFidelidadeModel>(response, "ObterDadosPromocaoFidelidade")
    } catch (error) {
        RegistrarLogErro(error, "ObterDadosPromocaoFidelidade", "")
        return { retornoErro: 1, mensagem: (error as Error).message }
    }
}

export const salvarPromocaoFidelidade = async function (
    authorization: string,
    payload: SalvarPromocaoPayload
): Promise<{ sucesso: boolean } | ErroApi> {
    try {
        const response = await api
            .post<RespostaRaw<{ sucesso: boolean }>>(
                "fornecedor/SalvarPromocaoFidelidade",
                payload,
                {
                    headers: { "Content-Type": "application/json", Authorization: authorization },
                }
            )
            .catch(function (error) {
                return { data: erroParaRespostaRaw(error) }
            })

        return tratamentoResponse<{ sucesso: boolean }>(response, "SalvarPromocaoFidelidade")
    } catch (error) {
        RegistrarLogErro(error, "SalvarPromocaoFidelidade", JSON.stringify(payload))
        return { retornoErro: 1, mensagem: (error as Error).message }
    }
}
